import styled from "styled-components";

export const FixedWidthContainer = styled.div`
  width: ${(props) => props.width ?? "fit-content"};
  min-width: ${(props) => props.width ?? "fit-content"};
  max-width: ${(props) => props.width ?? "fit-content"};
`;

export const FlexHorizontalContainer = styled(FixedWidthContainer)`
  display: flex;
  flex-direction: row;
`;

export const FlexVerticalContainer = styled(FixedWidthContainer)`
  display: flex;
  flex-direction: column;
`;

export const DynamicWidthContainer = styled.div`
  flex: 1;
`;
